module.exports = __webpack_public_path__ + "img/building_1.a0a14363.jpg";